const DEFAULT = 'Something went wrong. Please try again in a moment.';

/**
 * Maps axios / network failures to safe copy for the UI (no raw server payloads).
 * @param {unknown} err
 * @param {{ notFoundMessage?: string }} [options]
 */
export function getUserFacingApiError(err, options = {}) {
  if (!err || typeof err !== 'object') {
    return DEFAULT;
  }

  const response = err.response;
  if (response) {
    const status = response.status;
    if (status === 404) {
      return options.notFoundMessage || "We couldn't find what you were looking for.";
    }
    if (status >= 500) {
      return "We're having trouble on our end. Please try again shortly.";
    }
    if (status === 401 || status === 403) {
      return "You don't have access to this.";
    }
    if (status >= 400) {
      return DEFAULT;
    }
  }

  if (err.request) {
    return "We couldn't reach the server. Check your connection and try again.";
  }

  return DEFAULT;
}
